/**
 * Karte „Angaben aus der Anfrage“ (Reisegruppen-Widget T5): Anfragenummer, Wunschmonat oder „Termin noch
 * offen“, Gruppengröße und alles, was der Gast auf der Dankeseite nachgereicht hat. Damit Domenico sieht,
 * was ankam, ohne in Rohdaten zu suchen. Sie erscheint nur, wenn die Anfrage etwas davon trägt.
 */
import { Card, Icon } from "./components";
import { angabenZeilen, anfrageNummer } from "../lib/anfrage-angaben";
import type { AnfrageAngaben } from "./types";

export function AnfrageAngabenKarte({ inquiryId, angaben }: { inquiryId: string; angaben: AnfrageAngaben | null | undefined }) {
  const zeilen = angabenZeilen(angaben);
  if (zeilen.length === 0) return null;
  return (
    <Card className="p-5" data-testid="anfrage-angaben-karte">
      <div className="mb-3 flex items-center gap-2">
        <Icon name="assignment" className="text-[18px] text-primary" />
        <h3 className="text-[15px] font-bold text-on-background dark:text-inverse-on-surface">Angaben aus der Anfrage</h3>
        <span className="ml-auto rounded-full bg-surface-container-high px-2 py-0.5 font-label-md text-label-md font-semibold text-on-surface-variant" data-testid="anfrage-nummer">
          {anfrageNummer(inquiryId)}
        </span>
      </div>
      <dl className="space-y-2">
        {zeilen.map((z) => (
          <div key={z.key} className="grid grid-cols-[minmax(0,140px)_1fr] gap-x-3" data-testid={`angabe-${z.key}`}>
            <dt className="font-label-md text-label-md text-on-surface-variant">{z.label}</dt>
            <dd className="min-w-0 break-words font-body-sm text-body-sm text-on-surface dark:text-inverse-on-surface">
              {z.wert}
              {z.nachgereicht && <span className="ml-2 font-label-md text-[11px] text-on-surface-variant">nachgereicht</span>}
            </dd>
          </div>
        ))}
      </dl>
    </Card>
  );
}
